const $ = window.jQuery;

/**
 * Enables 'MWB WooCommerce Notices' plugin specific scripting
 */
const WooCommerceNotices = {

    duration: 3000,         // duration (ms) of auto-dismissing notices
    transitionTime: 200,    // duration (ms) of css notice element transitions
    $container: false,      // notices' container jQuery element
    templates: false,       // array of html used when adding notices dynamically
    clearing: false,        // whether we're currently clearing notices

    /**
     * Initialise functionality
     */
    init()
    {

        this.$container = $('.data-woocommerce-notices-container');
        this.templates = this.getTemplates();

        this.applySettings();

        this.clearNextNotice();

        this.bindManualNoticeClears();

        this.bindNoticesBlocker();

        // Show overlay if page already loads with notices
        if (this.$container.find('ul > li').length > 0) {
            this.showNotices();
        }

        // Listen to notice events
        $(window).on('mwb/plugin/woocommerce_notices/add_notice', (e, notice) => {
            const {message, type} = notice;
            this.addNotice(message, type);
        });

    },

    /**
     * Get the array of html used when adding notices dynamically
     */
    getTemplates()
    {
        return scriptVars.plugins.wooCommerceNotices.templates || [];
    },

    /**
     * Apply settings from container data attribute
     */
    applySettings()
    {

        const _duration = parseFloat(this.$container.data('notices-duration')) *
            1000;
        if (_duration) {
            this.duration = _duration;
        }

        const _transitionTime = parseFloat(
            this.$container.data('notices-transition-time')) * 1000;
        if (_transitionTime) {
            this.transitionTime = _transitionTime;
        }

    },

    /**
     * Get notice elements
     * @param {string} type Notice type to get
     * @param {string} excludeType Notice type to not get
     */
    getNotices(type = false, excludeType = false)
    {
        return this.$container.find(
            `ul > li${type ? `[data-notice-type="${type}"]` : ''}${excludeType
                ? `:not([data-notice-type="${excludeType}"])`
                : ''}`,
        );
    },

    /**
     * Get next notice that can be auto-dismissed (all notices that aren't type
     * 'error')
     */
    getNextAutoDismissableNotice()
    {

        // Get all notices that aren't type 'error'
        const $notices = this.getNotices(false, 'error');

        // Get the next element
        return $notices.length > 0 ? $($notices[0]) : false;

    },

    /**
     * Start process of clearing next notice to be auto-dismissed
     */
    clearNextNotice()
    {
        this.clearing = true;
        const nextNotice = this.getNextAutoDismissableNotice();
        if (nextNotice) {
            this.clearNotice(nextNotice);
        } else {
            this.clearing = false;
        }
    },

    /**
     * Start process of clearing notice (loading indication and then clearing it)
     * @param {jQuery el} $el Notice element
     */
    clearNotice($el = false)
    {

        if (!$el) {
            return;
        }

        let progress = $el.data('notice-progress') || 0;
        progress += this.transitionTime;

        // Update progress bar
        const $progressBar = $el.find('.woocommerce-notices-progress-bar');
        const progressPerc = (progress / this.duration).toFixed(2);
        $progressBar.css({
            'opacity': progressPerc,
            'width': `${Math.round(progressPerc * 100)}%`,
        });

        // Store new progress amount
        $el.data('notice-progress', progress);

        // Check notice should be cleared now
        if (progress >= this.duration) {
            this.clearNoticeImmediately($el, () => this.clearNextNotice());
        } else {
            setTimeout(() => this.clearNotice($el), this.transitionTime);
        }

    },

    /**
     * Clear/delete notice
     * @param {jQuery el} $el  Notice element
     * @param {function} cb Callback function after element is removed
     */
    clearNoticeImmediately($el = false, cb = false)
    {

        $el.addClass('opacity-0 h-0 py-0');

        // Allow transition before removing element entirely
        setTimeout(() => {

            $el.remove();

            // Run callback if given
            if (cb) {
                cb();
            }

            // Check if there's no remaining notices
            if (!this.getNotices().length) {
                this.hideNotices();
            }

        }, this.transitionTime);

    },

    /**
     * Add listeners to "clear notice" buttons
     */
    bindManualNoticeClears()
    {

        let vm = this;

        let $buttons = vm.$container.find(
            'li [data-notice-close], li a[href="javascript:;"]');

        $buttons.off('click');
        $buttons.on('click', function() {
            const $notice = $(this).closest('li');
            vm.clearNoticeImmediately($notice);
        });

    },

    /**
     * Add listeners to any notice links that wouldn't change the page
     */
    bindManualNoticeHashLinks()
    {

        let vm = this;

        let $links = vm.$container.find('a[href^="#"]');

        $links.off('click');
        $links.on('click', function() {
            const $notice = $(this).closest('li');
            vm.clearNoticeImmediately($notice);
        });

    },

    /**
     * Add listener to "clear all notices" blocker/button
     */
    bindNoticesBlocker()
    {

        const vm = this;

        vm.$container.find('.data-woocommerce-notices-blocker').
        on('click', function() {
            vm.clearNoticeImmediately(vm.getNotices());
        });

    },

    /**
     * Show notices and it's half-transparent backing element
     */
    showNotices()
    {
        this.$container.removeClass('opacity-0 pointer-events-none');
    },

    /**
     * Hide notices and it's half-transparent backing element
     */
    hideNotices()
    {
        this.$container.addClass('opacity-0 pointer-events-none');
    },

    /**
     * Add a notice
     * @param {string} message Message of message
     * @param {string} type Type of notice
     */
    addNotice(message, type = 'notice')
    {

        let html = (this.templates[type] || '').replace('{%message%}', message);

        // Give up if we failed to get the html
        if (!html) {
            return;
        }

        // Add notice html
        this.$container.find('ul').append($(html));
        this.bindManualNoticeClears();
        this.bindManualNoticeHashLinks();
        this.showNotices();

        // Restart clearing process if thereit's not already running
        if (!this.clearing) {
            this.clearNextNotice();
        }

    },

};

export default WooCommerceNotices;